angular
	.module('components.inicial')
	.controller('InicialController', InicialController);

function InicialController($window, $http, $scope, $state, URL_LOGOS, URL_IPTUBR, ngDialog, InicialService) {
	var vm = this;

	vm.url_logo = URL_LOGOS;
	vm.url_iptubr = URL_IPTUBR;

	var map = new ol.Map({
		layers: [],
		controls: [],
		target: 'mapa-inicio',
		view: new ol.View({
			center: [-6100286.3534, -1668161.7053],
			zoom: 4 /* o método centralizarExtentBrasil posiciona corretamente o zoom */
		}),
		interactions: [],
	});

	vm.ajustarMapa = function () {
		adicionarMapaBrasil();
		centralizarExtentBrasil();
		eventoClick();

		// diversos
		carregarClientes();
	};

	function carregarClientes() {
		InicialService.buscarClientes().then(function (result) {
			vm.clientes = result.data;
		});
	}

	function centralizarExtentBrasil() {
		map.getView().fit(InicialService.buscarExtentBrasil(), map.getSize());
	}

	function adicionarMapaBrasil() {
		map.addLayer(InicialService.buscarWmsBrasil());
	}

	function eventoClick() {
		map.on('singleclick', function (evt) {
			map.getLayers().forEach(function (layer, index) {
				var url = layer.getSource().getGetFeatureInfoUrl(
					evt.coordinate, map.getView().getResolution(),
					map.getView().getProjection(),
					{'INFO_FORMAT': 'application/json'}
				);
				if (url) {
					$http.get(url).then(function (result) {
						if (result.data.features.length > 0) {
							vm.informacaoEstado = result.data.features[0].properties;
							vm.clientes_estado = _.where(
								vm.clientes, {'clien_id_gpx_uf': vm.informacaoEstado['id_gpx_uf'].toString()}
							);
							ngDialog.open({
								template: 'modalClientes',
								className: 'ngdialog-theme-default',
								width: '60%',
								scope: $scope
							});
						}
					});
				}
			});
		});
	}

}
